module.exports = __webpack_public_path__ + "img/secplusicon.bd1b2182.svg";